














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ButtonWidgetComponent extends Vue {

  @Prop(String) public buttonText!: string;
  @Prop(Object) public buttonTextParams!: { [key: string]: string };
  @Prop([String, Array]) public buttonIcon!: string | string[];
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public buttonIconSpin!: boolean;
  @Prop(Boolean) public buttonLoading!: boolean;
  @Prop(Boolean) public flipOnHover!: boolean;
  @Prop(Boolean) public smallBtn!: boolean;

  private mouseOver: boolean = false;

  public onClick(event: any): void {
    this.$emit('onClick', this);
  }
}
